import { Route, Routes, Navigate } from 'react-router-dom'

import KitchensPage from "../pages/shared/KitchensPage";
// import KitchenInfo from "../pages/shared/KitchenInfo";
import KitchenDetails from "../pages/shared/KitchenDetails";

import MembersPage from "../pages/auth/MembersPage";
// import RequestsPage from "../pages/auth/RequestsPage";
import MemberInfo from "../pages/auth/MemberInfo";

import Account from '../pages/auth/Account'
import Preferences from "../pages/auth/Preferences";
import EditPreference from '../pages/auth/EditPreference';
import Messages from '../pages/auth/Messages'
import Inventory from '../pages/auth/Inventory'
import Settings from '../pages/auth/Settings'

import Bookings from '../pages/auth/Bookings'
import BookingDetail from '../molecules/BookingDetail'
import { CommunitySchema } from '../data/types';



type AuthViewProps = {
    primaryCommunity?: CommunitySchema
}
const AuthView: React.FC<AuthViewProps> = ({primaryCommunity}) => {

    if (primaryCommunity && primaryCommunity.active) {
        return (
            <div className='w-10/12 ml-auto sm:w-full'>
                <Routes>
                    
                        <Route path="/kitchens" element={(<KitchensPage />)} />
                        <Route path="/kitchens/members" element={(<MembersPage />)} />
                        {/* <Route path="/kitchens/members/requests" element={(<RequestsPage />)} /> */}
                        <Route path="/kitchens/preferences" element={(<Preferences />)} />
                        <Route path="/kitchens/preferences/edit/:category" element={(<EditPreference/>)}/>
                        <Route path="/kitchens/reservations" element={(<Bookings/>)} />
                        <Route path="/kitchens/reservations/:bookingId" element={<BookingDetail />} />
                        <Route path="/messages" element={<Messages />} />
                        <Route path="/kitchens/:kitchenid" element={(<KitchenDetails />)} />
                        <Route path="/kitchens/members/:memberid" element={(<MemberInfo />)} />
                        <Route path="/inventory" element={(<Inventory />)} />
                        <Route path="/settings" element={(<Settings />)} />
                        <Route path="/account" element={(<Account />)} />
                        <Route path="*" element={<Navigate replace to="/kitchens" />} />
                </Routes>
            </div>
        )
    } else if (primaryCommunity && !primaryCommunity.active) {
        return (
        <>
            <div className='w-10/12 ml-auto sm:w-full'>
                <div className="flex flex-col justify-center items-center w-full bg-back-400 h-screen text-[#013847]">
                    <svg
                        aria-hidden="true"
                        className="w-14 h-14 mr-2 text-gray-200 animate-spin  fill-primary-400 m-2"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                        />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                        />
                    </svg>
                    Community Approval Pending
                    <p className='text-sm italic '>
                        Please Check Back Later
                    </p>
                </div>
            </div>
        </>
        )
    } else {
        return (
        <div className='w-10/12 ml-auto sm:w-full'>
            <div className="flex flex-col justify-center items-center w-full bg-back-400 h-screen text-[#013847]">
                No Community Yet
            </div>
        </div>
        )
    }
}


export default AuthView;